/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Search_PlaceholderInputs */

const en_colleague_search_placeholder = /** @type {(inputs: Colleague_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket number…`)
};

const ja_colleague_search_placeholder = /** @type {(inputs: Colleague_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チケット番号…`)
};

const fr_colleague_search_placeholder = /** @type {(inputs: Colleague_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de ticket…`)
};

const de_colleague_search_placeholder = /** @type {(inputs: Colleague_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketnummer…`)
};

/**
* | output |
* | --- |
* | "Ticket number…" |
*
* @param {Colleague_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_search_placeholder = /** @type {((inputs?: Colleague_Search_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Search_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_search_placeholder(inputs)
	if (locale === "ja") return ja_colleague_search_placeholder(inputs)
	if (locale === "fr") return fr_colleague_search_placeholder(inputs)
	return de_colleague_search_placeholder(inputs)
});